import { cn } from '@/lib/utils'
import { motion } from 'motion/react'
import { ReactNode } from 'react'

interface AnimatedPageHeaderProps {
  title: string | ReactNode
  description?: string | ReactNode
  /** @deprecated kept for backwards compatibility, no longer used */
  titleLevel?: 1 | 2 | 3 | 4 | 5
  /** @deprecated kept for backwards compatibility, no longer used */
  descriptionLevel?: 1 | 2 | 3 | 4 | 5
  className?: string
}

// Animation variants for header
const headerVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
}

// Animation variants for description
const descriptionVariants = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      delay: 0.2,
      ease: 'easeOut'
    }
  }
}

export function AnimatedPageHeader({
  title,
  description,
  className
}: AnimatedPageHeaderProps) {
  return (
    <div className={cn('mb-6', className)}>
      <motion.div
        variants={headerVariants}
        initial="hidden"
        animate="visible"
        className="flex items-center gap-3"
      >
        <span
          aria-hidden
          className="h-7 w-1.5 shrink-0 rounded-full bg-gradient-to-b from-primary to-peach sm:h-9"
        />
        <h1 className="m-0 font-display text-[1.75rem] font-bold leading-tight tracking-tight text-ink sm:text-[2.25rem]">
          {title}
        </h1>
      </motion.div>
      {description && (
        <motion.div
          variants={descriptionVariants}
          initial="hidden"
          animate="visible"
        >
          <p className="mt-3 max-w-2xl text-[15px] leading-relaxed text-muted-foreground sm:pl-[18px]">
            {description}
          </p>
        </motion.div>
      )}
    </div>
  )
}
